import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { PublicEvents, triggerPublicEvent } from '@project/shared/utils/events/js/events';
import * as copy from 'copy-to-clipboard';

const jsClass = 'js-m-page-share__anchor';

@createModule('PageShare')
/**
 * ListIcons Component
 * @constructor
 */
export class PageShare extends TerrificSpec {
	// eslint-disable-next-line no-undef
	clipboardAnchor: HTMLElement;

	/**
	 * Start / Init Nitro lifecycle hook
	 * @param {function} resolve Required parameter for start lifecycle
	 * @returns {void}
	 */
	start(resolve: Function): void {
		resolve();

		this.setClipboardAnchorBtn();

		if (this.isClipboardAnchorBtn()) {
			this.clipboardAnchor.addEventListener('click', () => this.copyURLToClipboard());
		}
	}

	/**
	 * set clipboard anchor context reference
	 * @returns {void}
	 */
	setClipboardAnchorBtn() {
		this.clipboardAnchor = <HTMLElement>this._ctx.querySelectorAll('.m-icon-hyperlink')[0].parentNode;
	}

	/**
	 * Copies the URL (location.href) into the browser clipboard
	 * @constructor {function}
	 * @returns {void}
	 */
	copyURLToClipboard(): void {
		const opts: any = this.getClipboardOpts();
		const data = this.getLocationHref();

		this.showDebugInfo(opts, data);
		this.showFeedbackMsg();
		copy(data, opts);
		this.hideFeedbackMsgTimer();
	}

	/**
	 * getClipboardOpts
	 * @constructor {function} getClipboardOpts
	 * @returns {Object} any
	 */
	getClipboardOpts(): any {
		return {
			debug: false,
			message: 'Press #{⌘+C} on macOS or #{Ctrl+C} on Windows to copy',
		};
	}

	/**
	 * getLocationHref
	 * @constructor {function} getLocationHref
	 * @returns {string} string
	 */
	getLocationHref(): string {
		return document.location.href;
	}

	/**
	 * showDebugInfo - Description
	 * @constructor {function} showDebugInfo
	 * @param {Object} opts holds thze options for the clipboard object
	 * @param {string} data holds the data to be copied into the clipboard
	 */
	showDebugInfo(opts: any, data: string) {
		if (opts.debug) {
			// eslint-disable-next-line no-console
			console.log('Copied to clipboard: ', data);
		}
	}

	/**
	 * showFeedbackMsg
	 * @constructor {function} showFeedbackMsg
	 */
	showFeedbackMsg() {
		const ctx: HTMLElement = this._ctx;
		ctx.previousElementSibling.classList.remove('show');
		ctx.previousElementSibling.classList.add('show');
	}

	/**
	 * hideFeedbackMsg
	 * @constructor {function} hideFeedbackMsg
	 */
	hideFeedbackMsg() {
		const ctx: HTMLElement = this._ctx;
		ctx.previousElementSibling.classList.remove('show');
	}

	/**
	 * showFeedbackMsg
	 * @constructor {function} showFeedbackMsg
	 */
	hideFeedbackMsgTimer() {
		window.setTimeout(() => {
			this.hideFeedbackMsg();
		}, 3500);
	}

	/**
	 * back-to-top button should contain the 'm-page-share' css class that comes from the button modifier 'top'
	 * to separate its click event
	 * @returns {boolean} boolean
	 */
	isClipboardAnchorBtn(): boolean {
		return this.clipboardAnchor.classList.contains(jsClass);
	}

	/**
	 * stop/destroy Nitro lifecycle hook
	 * @returns {void}
	 */
	stop(): void {
		if (this.isClipboardAnchorBtn()) {
			this._ctx.removeEventListener('click', () => {});
		}
	}

	/**
	 * Nitro triggerPublicEvent
	 * @returns {void}
	 */
	_triggerChangeEvent(): void {
		triggerPublicEvent(PublicEvents.uxChange, this, this._ctx);
	}
}

export default PageShare;
